import { localstorage_add_log } from './custom_methods';
const record = () => {
  // const visits = JSON.parse(localStorage.getItem('visits')) || [];
  // const newVisit = {
  //   link: window.location.href,
  //   refferrer: document.referrer,
  // };
  // visits.push(newVisit);
  // console.log(document.referrer);
  // localStorage.setItem('visits', JSON.stringify(visits));
  if(document.referrer.indexOf("vomsis.com")<0){
    localstorage_add_log("visit",document.referrer,document.URL);
  }
};

export default record;
